import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from '../cookieService/cookie.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private cookie: CookieService,private translate: TranslateService) {
    
    this.translate.setDefaultLang('eng');
  }

  private languageSource = new BehaviorSubject<string>(this.cookie.get("selectedLanguage") || 'eng');
  language$ = this.languageSource.asObservable();

  setLanguage(lang: string) {
    // localStorage.setItem('selectedLanguage', lang);
    this.cookie.set("selectedLanguage", lang);
    this.translate.use(lang);
    this.languageSource.next(lang);
  }

  getLanguage(): string {
    // return localStorage.getItem('selectedLanguage') || 'eng';
    return this.cookie.get("selectedLanguage") || 'eng';
  }

  getLoginLanguage() : string {
    return this.cookie.get("selectedLanguage") || '';
  }
}
